import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class InactivitylockscreenService {
  private timeoutId: any;
  private readonly timeoutSeconds = 60;  // 5 minutes for 300 Seconds
  private events = [
    'mousedown', 'mousemove', 'keydown', 'keyup', 'input', 'scroll',
    'touchstart', 'touchend', 'touchcancel', 'touchmove', 'click'
  ];
  private isBrowser: boolean;

  constructor(
    private router: Router,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  initInactivityTimer() {
    if (!this.isBrowser) return; // prevent running on server

    //this.resetTimer();

    this.ngZone.runOutsideAngular(() => {
      this.events.forEach(event =>
        document.addEventListener(event, this.resetTimer.bind(this), true)
      );
    });
  }

  private resetTimer() {
    // if (!this.isBrowser) return;
    // clearTimeout(this.timeoutId);
    // this.timeoutId = setTimeout(() => {
    //   localStorage.setItem('isLocked', 'true');  // <- mark locked
    //   const isAuthenticated = !!sessionStorage.getItem('loginToken');
    //   if (isAuthenticated) {
    //     this.ngZone.run(() => {
    //       this.router.navigate(['/lock-screen']);
    //     });
    //   } else {
    //     this.ngZone.run(() => {
    //       this.router.navigate(['/']);
    //     });
    //   }
    // }, this.timeoutSeconds * 1000);
  }

  // private resetTimer() {
  //   console.log('test');
  //   if (!this.isBrowser) return;

  //   clearTimeout(this.timeoutId);
  //   this.timeoutId = setTimeout(() => {
  //     this.ngZone.run(() => {
  //       this.router.navigate(['/lock-screen']);
  //     });
  //   }, this.timeoutSeconds * 1000);
  // }

  stopTimer() {
    if (!this.isBrowser) return;

    clearTimeout(this.timeoutId);
    this.events.forEach(event =>
      document.removeEventListener(event, this.resetTimer.bind(this), true)
    );
  }
}